import React, { useMemo } from "react";
import { HyperframesPlayer } from "../hyperframesPlayer";
import { FORMAT_DIMENSIONS, FPS, buildTemplateComposition } from "../lib/hyperframesCompositions";
import type { TemplateId } from "@engine/templates/index";
import type { FormatId } from "@engine/hyperframes/format";

type Props = {
  templateId: string;
  format: string;
  inputProps: Record<string, unknown>;
  durationSeconds: number;
};

export const PlayerPreview: React.FC<Props> = ({ templateId, format, inputProps, durationSeconds }) => {
  const dims = FORMAT_DIMENSIONS[(format as FormatId)] ?? FORMAT_DIMENSIONS["9:16"];
  const displayWidth = useMemo(() => {
    if (format === "9:16") return 240;
    if (format === "1:1") return 360;
    return 440;
  }, [format]);
  const displayHeight = Math.round((displayWidth * dims.height) / dims.width);

  const composition = useMemo(
    () => buildTemplateComposition(templateId as TemplateId, format as FormatId, "de", inputProps),
    [templateId, format, inputProps],
  );

  if (!composition) {
    return <div className="empty">Unbekanntes Template: {templateId}</div>;
  }

  return (
    <div className="player-shell" style={{ width: displayWidth, height: displayHeight }}>
      <HyperframesPlayer
        srcDoc={composition.html}
        compositionWidth={dims.width}
        compositionHeight={dims.height}
        fps={FPS}
        displayWidth={displayWidth}
        displayHeight={displayHeight}
        controls
        loop
        autoPlay
      />
    </div>
  );
};

// Silence unused export warning on consumers that import the legacy
// durationSeconds prop. The Hyperframes player infers duration from the
// composition HTML, but we accept the prop for API compatibility.
void (null as unknown as number);
